export default __webpack_public_path__ + "img/LkwnbOcg.84cd09b5.svg";